import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { ComparisonFeature } from '../types';

interface ComparisonTableProps {
  features: ComparisonFeature[];
}

const ComparisonTable = ({ features }: ComparisonTableProps) => {
  const [expandedCategories, setExpandedCategories] = useState<string[]>([]);

  const toggleCategory = (category: string) => {
    setExpandedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const renderFeatureValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="Check" size={20} className="text-success mx-auto" />
      ) : (
        <Icon name="X" size={20} className="text-muted-foreground mx-auto" />
      );
    }
    return <span className="text-sm text-text-secondary">{value}</span>;
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-surface border-b border-border">
            <tr>
              <th className="text-left p-4 font-semibold text-text-primary min-w-[250px]">
                Features
              </th>
              <th className="text-center p-4 font-semibold text-text-primary min-w-[150px]">
                Starter
              </th>
              <th className="text-center p-4 font-semibold text-text-primary min-w-[150px]">
                Professional
              </th>
              <th className="text-center p-4 font-semibold text-text-primary min-w-[150px]">
                Enterprise
              </th>
            </tr>
          </thead>
          <tbody>
            {features.map((category, categoryIndex) => (
              <>
                <tr className="border-t border-border bg-surface/50">
                  <td colSpan={4} className="p-4">
                    <button
                      onClick={() => toggleCategory(category.category)}
                      className="flex items-center justify-between w-full text-left hover:text-primary transition-colors duration-fast"
                    >
                      <span className="font-semibold text-text-primary">{category.category}</span>
                      <Icon
                        name="ChevronDown"
                        size={20}
                        className={`transition-transform duration-fast ${
                          expandedCategories.includes(category.category) ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                  </td>
                </tr>
                {expandedCategories.includes(category.category) &&
                  category.features.map((feature, featureIndex) => (
                    <tr
                      key={featureIndex}
                      className="border-t border-border hover:bg-surface/30 transition-colors duration-fast"
                    >
                      <td className="p-4">
                        <div>
                          <div className="font-medium text-text-primary text-sm">
                            {feature.name}
                          </div>
                          <div className="text-xs text-text-secondary mt-1">
                            {feature.description}
                          </div>
                        </div>
                      </td>
                      <td className="p-4 text-center">{renderFeatureValue(feature.starter)}</td>
                      <td className="p-4 text-center">
                        {renderFeatureValue(feature.professional)}
                      </td>
                      <td className="p-4 text-center">{renderFeatureValue(feature.enterprise)}</td>
                    </tr>
                  ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComparisonTable;